export default _module
export const {
  Module,
  builtinModules,
  runMain,
  wrap,
} = _module